module.exports = __webpack_public_path__ + "img/ok.03f7daa7.svg";